import React from "react";
import { Link } from "react-router-dom";
import {
  ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID,
  ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_IOS,
  ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_ANDROID,
} from "../utils/config";
const UE_LOGO = require("../assets/ue_logo.png");
const APP_STORE = require("../assets/appstore.png");
const GOOGLE_PLAY = require("../assets/gplay.png");

const renderUrl = (title, articleId) => (
  <Link
    to={{
      pathname: "/article",
      article: articleId,
    }}
  >
    {title}
  </Link>
);
const Footer = () => (
  <footer className="footer mt-auto">
    <div className="container">
      <div className="row">
        <div className="col-md-8">
          <img
            alt="UE logotypy"
            src={UE_LOGO}
            className="img-fluid img-footer-logo"
          />
        </div>
        <div className="col-md-4 d-flex flex-column ml-auto justify-content-between">
          <div className="row">
            <div className="col-12">
              <div className="small text-muted">Pobierz aplikację ze sklepów:</div>
              <a href="https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1396395087&mt=8">
                <img
                  alt="Pobierz z App Store"
                  src={APP_STORE}
                  className="img-fluid app-shop-url mb-0 mb-md-2 mb-lg-0 mx-2 mx-md-0"
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.fishmarket">
                <img
                  alt="Pobierz z Google Play"
                  src={GOOGLE_PLAY}
                  className="img-fluid app-shop-url mx-2 mx-md-0"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="row small footer-urls mt-1">
        <div className="col-12 text-right">
          <Link to="/">&copy; Ustka {new Date().getFullYear()}</Link>
          &nbsp;&nbsp;&nbsp;
          {renderUrl(
            "Deklaracja dostępności",
            ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID
          )}
          &nbsp;
          {renderUrl("iOS", ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_IOS)}
          &nbsp;
          {renderUrl("Android", ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_ANDROID)}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/screens/Footer.js